/* eslint-disable react/no-danger */
import { FC } from 'react'
import styled from 'styled-components'
import Aside from 'src/components/Aside/Aside'
import Divider from 'src/containers/Post/components/Divider'
import { IArtist } from 'src/types'

const PostContainer = styled.section`
  display: flex;
  margin: 0 auto;
  margin-top: 48px;
  max-width: 1200px;
`

const Article = styled.article`
  width: 100%;
  margin-left: 24px;

  h1 {
    margin-top: 0;
    text-align: center;
  }

  .media-wrap {
    margin: 20px 0;
    text-align: center !important;

    img {
      max-width: 750px;
    }
  }

  p {
    line-height: 1.6;
  }

  figure {
    text-align: center;

    img {
      max-height: 200px;
    }
  }

  a {
    color: #000 !important;
  }
`

interface Props {
  artist: IArtist
}

const Post: FC<Props> = ({ artist }) => {
  const { name, avatarUrl, introductionHTML } = artist
  return (
    <PostContainer>
      <Aside />
      <Article>
        <h1>{name}</h1>
        <figure>
          <img src={avatarUrl} alt={name} />
        </figure>
        <main dangerouslySetInnerHTML={{ __html: introductionHTML }} />
        <Divider />
      </Article>
    </PostContainer>
  )
}

export default Post
